import { PlayerDataGQL, Team, TeamGQL } from '../../Api'
import { MAIN_PLL_URL, PLL_IMAGES, PLL_LINKS } from '../../Config/config'
import { DynamicLinkParam, createDynamicLink } from '../../Routing/utils'

export const APP_LINKS = {
  homeCallout: PLL_LINKS.homepageAppLink,
}

export const createProfileDynamicLink = () => {
  let pageId = 'UserProfile'
  let webUrl = 'https://premierlacrosseleague.com/login'
  let params: DynamicLinkParam[] = []
  const social = {
    title: 'PLL Profile',
    description: 'View your PLL Profile',
    image: PLL_IMAGES.pllAppFeaturedImage,
  }
  return createDynamicLink(params, pageId, webUrl, social)
}

export const createStandingsDynamicLink = (appOnly: boolean = false) => {
  let pageId = 'Standings'
  let webUrl = 'https://premierlacrosseleague.com/standings'
  let params: DynamicLinkParam[] = []
  if (!appOnly) {
    params = [
      {
        title: '$ios_url',
        value: webUrl,
      },
      {
        title: '$android_url',
        value: webUrl,
      },
      {
        title: '$desktop_url',
        value: webUrl,
      }
    ]
  }

  const social = {
    title: 'PLL Standings',
    description: 'View PLL team standings, records, and score differentials.',
    image: PLL_IMAGES.pllAppFeaturedImage,
  }
  return createDynamicLink(params, pageId, webUrl, social)
}

export const createScoresDynamicLink = (appOnly: boolean = false) => {
  let pageId = 'Schedule'
  let webUrl = 'https://premierlacrosseleague.com/scores'
  let params: DynamicLinkParam[] = []
  if (!appOnly) {
    params = [
      {
        title: '$ios_url',
        value: webUrl,
      },
      {
        title: '$android_url',
        value: webUrl,
      },
      {
        title: '$desktop_url',
        value: webUrl,
      }
    ]
  }

  const social = {
    title: 'PLL Scores',
    description: 'View the scores and schedule of all PLL games.',
    image: PLL_IMAGES.pllAppFeaturedImage,
  }
  return createDynamicLink(params, pageId, webUrl, social)
}

export const createMatchupPreviewDynamicLink = (
  eventSlug: string,
  appOnly: boolean = false
) => {
  let pageId = 'GamePreview'
  let webUrl = `https://premierlacrosseleague.com/matchup/${eventSlug}`
  let params = [
    {
      title: 'eventSlug',
      value: eventSlug,
    },
  ]
  if (!appOnly) {
    params = [
      ...params,
      {
        title: '$ios_url',
        value: webUrl,
      },
      {
        title: '$android_url',
        value: webUrl,
      },
      {
        title: '$desktop_url',
        value: webUrl,
      }
    ]
  }

  const social = {
    title: 'PLL Game Preview',
    description: 'View the matchup Preview',
    image: PLL_IMAGES.pllAppFeaturedImage,
  }
  return createDynamicLink(params, pageId, webUrl, social)
}

export const createPlayerDynamicLink = (
  player: PlayerDataGQL,
  tab: string = 'Profile',
  appOnly: boolean = false
) => {
  let pageId = 'PlayerProfile'
  let sTitle = `${player.firstName} ${player.lastName} Profile & Stats`.trim()
  let url = `https://${MAIN_PLL_URL}/player/${player.slug}`
  let params = [
    {
      title: 'slug',
      value: player.slug,
    },
    {
      title: 'tab',
      value: tab,
    },
  ]

  if (!appOnly) {
    params = [
      ...params,
      {
        title: '$ios_url',
        value: url,
      },
      {
        title: '$android_url',
        value: url,
      },
      {
        title: '$desktop_url',
        value: url,
      }
    ]
  }

  const social = {
    title: sTitle,
    image: player?.profileUrl || PLL_IMAGES.pllAppFeaturedImage,
  }
  return createDynamicLink(params, pageId, url, social)
}

export const createTeamDynamicLink = (
  team: TeamGQL | Team,
  tab: string = 'overview',
  appOnly: boolean = false
) => {
  let pageId = 'TeamProfile'
  let webUrl = `https://premierlacrosseleague.com/teams/${team.fullName}`
  let params = [
    {
      title: 'teamID',
      value: team.officialId,
    },
    {
      title: 'tab',
      value: tab,
    },
  ]

  if (!appOnly) {
    params = [
      ...params,
      {
        title: '$ios_url',
        value: webUrl,
      },
      {
        title: '$android_url',
        value: webUrl,
      },
      {
        title: '$desktop_url',
        value: webUrl,
      }
    ]
  }

  const social = {
    title: `${team.location || ''} ${team.fullName} ${tab}`,
    image: team.teamLogo,
  }
  return createDynamicLink(params, pageId, webUrl, social)
}
